import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { coreProviders } from './core/core.config';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), ...coreProviders],
};
